/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class UndoRedoInternalAPI
 * @hideconstructor
 * @classdesc  Internal API class that handles undo and redo functionality for internal purpose
 */
define([], () => {
	return class UndoRedoInternalAPI {
		/**
		 * @function UndoRedoAPI#isDirty
		 * @description Determine whether the undo/redo stack is dirty
		 */
		isDirty() {}

		/**
		 * @function UndoRedoAPI#setDirty
		 * @description Marks the undo/redo stack as dirty
		 */
		setDirty() {}

		/**
		 * @function UndoRedoAPI#setMode
		 * @description sets the undo/redo controller mode
		 * @param {string} mode undo/redo controllder mode
		 */
		setMode() {}

		/**
		 * @function UndoRedoAPI#addToUndoRedoStack
		 * @description adds an action to the undo/redo stack
		 * @param {object} action undoRedo action
		 */
		addToUndoRedoStack() {}

		/**
		 * @function UndoRedoAPI#addListener
		 * @description Adds a lister to undo/redo changes
		 */
		addListener() {}

		/**
		 * @function UndoRedoAPI#removeListener
		 * @description remove a lister to undo/redo changes
		 */
		removeListener() {}

		/**
		 * @function UndoRedoAPI#registerSaveAction
		 * @description marks all undo-able actions in the stack as dirty
		 */
		registerSaveAction() {}


		/**
		 * @function UndoRedoAPI#registerAPIEvents
		 * @description register an API with event support to the undo/redo controller
		 * @param {object} api API instace created by the APIFactory with event support
		 */
		registerAPIEvents() {}
	};
});
